import {useMutation} from '@tanstack/react-query';
import creatorsUpdaters from '@/api/updaters/creators';
import invalidateCampaignInvitedQueries, {
  invalidateCampaignInvitedQueriesAfterEnqueue,
} from '@/views/campaigns/creators-tab/utils/invalidateCampaignInvitedQueries';
import {CreatorProps} from '@/views/creators/components/creator-action/action/ActionProps';
import {isOffPlatformCreator} from '@/views/creators/creator-crm/utils/offPlatformSource';

export type SendCampaignInvitesVariables = {
  agencyId: string;
  campaignId: string;
  creators: CreatorProps[];
  personalNote?: string;
};

function useSendCampaignInvites() {
  return useMutation({
    mutationKey: ['creators', 'sendCampaignInvites'],
    mutationFn: ({
      agencyId,
      campaignId,
      creators,
      personalNote,
    }: SendCampaignInvitesVariables) => {
      const offPlatformCreatorIds = creators
        .filter(isOffPlatformCreator)
        .map((creator) => creator.id);
      const profileIds = creators
        .filter((creator) => !isOffPlatformCreator(creator))
        .map((creator) => creator.id);

      return creatorsUpdaters.sendCampaignInvites({
        agencyId,
        campaignId,
        profileIds,
        offPlatformCreatorIds,
        personalNote: offPlatformCreatorIds.length ? personalNote : undefined,
      });
    },
    onSuccess: (result) => {
      if (result.offPlatformEnqueued > 0) {
        invalidateCampaignInvitedQueriesAfterEnqueue();
      } else {
        invalidateCampaignInvitedQueries();
      }
    },
  });
}

export default useSendCampaignInvites;
